var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-flex"}},[_c('input',_vm._g({ref:"input",staticStyle:{"width":"100%"},attrs:{"required":_vm.required,"readonly":_vm.readonly,"placeholder":_vm.placeholder}},_vm.listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }